import { useAuthentication as useSharedAuthentication } from '@starjack/features/authentication';
import {
    deleteFromLocalStorage,
    getFromLocalStorage,
    saveToLocalStorage,
} from '@/utils';
import { LOCAL_STORAGE_KEY_AUTH, isB2B } from '@/constants';
import { isOfTypeBackendError, isOfTypeString } from '@/utils/guards';

export const useAuthentication = () => {
    return useSharedAuthentication({
        isB2B,
        localStorageKey: LOCAL_STORAGE_KEY_AUTH,
        getFromLocalStorage,
        saveToLocalStorage,
        deleteFromLocalStorage,
        isOfTypeBackendError,
        isOfTypeString,
        extractAuthOptions: {
            tokenExpiresAtMultiplier: 0.5, // B2B uses validFor / 2
            usePermissionsFromJwt: true, // B2B uses permissions from JWT
        },
        refreshTimeLeftMultiplier: 0.75,
        enableUrlAuth: true,
    }) as ReturnType<typeof useSharedAuthentication> & {
        login: (
            username: string,
            password: string
        ) => Promise<[unknown, string | null]>;
        logout: () => void;
        isLoggedIn: () => [boolean, 'no_jwt' | 'token_expired' | null];
        saveAuthDataFromUrl: () => boolean;
        authenticateFromLocalStorageData: () => boolean;
    };
};
